import hotKeys from '../config/staff-info/hot-keys.json';

const STAFF_SEQUENCE = hotKeys.staffInfoSequence;
const RESET_TIMEOUT_MS = hotKeys.resetTimeoutMs;
let sequenceIndex = 0;
let resetTimer = null;

const LEGACY_ARROW_KEYS = {
    Up: 'ArrowUp',
    Down: 'ArrowDown',
    Left: 'ArrowLeft',
    Right: 'ArrowRight',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown'
};

function isEditableTarget(target) {
    if (!(target instanceof HTMLElement)) return false;
    if (target.isContentEditable) return true;

    return Boolean(target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])'));
}

function resetSequence() {
    sequenceIndex = 0;
    clearTimeout(resetTimer);
    resetTimer = null;
}

function scheduleReset() {
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
        sequenceIndex = 0;
        resetTimer = null;
    }, RESET_TIMEOUT_MS);
}

function getNormalizedKey(event) {
    const rawKey = event.key ?? LEGACY_ARROW_KEYS[event.which] ?? LEGACY_ARROW_KEYS[event.keyCode];
    return LEGACY_ARROW_KEYS[rawKey] ?? rawKey;
}

function openStaffInfoPage() {
    const popup = window.open('/staff-info', '_blank', 'noopener');

    if (!popup) {
        window.location.assign('/staff-info');
    }
}

function handleStaffInfoSequence(event) {
    if (event.defaultPrevented || event.repeat) return;
    if (event.ctrlKey || event.metaKey || event.altKey) return;
    if (isEditableTarget(event.target)) return;

    const key = getNormalizedKey(event);
    if (!key) return;

    if (key === STAFF_SEQUENCE[sequenceIndex]) {
        sequenceIndex += 1;

        if (sequenceIndex === STAFF_SEQUENCE.length) {
            resetSequence();
            openStaffInfoPage();
            return;
        }

        scheduleReset();
        return;
    }

    if (key === STAFF_SEQUENCE[0]) {
        sequenceIndex = 1;
        scheduleReset();
        return;
    }

    resetSequence();
}

document.addEventListener('keydown', handleStaffInfoSequence, true);

export {
    getNormalizedKey,
    handleStaffInfoSequence,
    isEditableTarget,
    openStaffInfoPage
};
